import { BaseTypeEnum } from 'src/app/product-capture/model/consts/participation-base-type.const';
import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';
import {
  PAYOFF_CALLABILITY_CALLABILITY,
  PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
  PAYOFF_COUPON,
  PAYOFF_COUPON_REFERENCE_RATE,
  PAYOFF_COUPON_TYPE,
  PAYOFF_PARTICIPATION,
  PAYOFF_PARTICIPATION_BASE_TYPE,
  PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE,
  PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
  PAYOFF_PARTICIPATION_UPSIDE_TYPE,
  SUMMARY_FREQUENCY,
  SUMMARY_PERFORMANCE_TYPE,
  SUMMARY_REFERENCE_ENTITIES,
  SUMMARY_SETTLEMENT_TYPE,
  SUMMARY_UNDERLYING_ASSETS_GROUP,
} from '../../mockups/consts/product-capture-field-selectors.consts';

export const BONUS_CERTIFICATE_SETTINGS = {
  id: ProductTypeEnum.BONUS_CERTIFICATE,
  label: 'Bonus Certificate',
  effects: [
    {
      formControlNames: [
        SUMMARY_REFERENCE_ENTITIES,
        PAYOFF_COUPON_REFERENCE_RATE,
        PAYOFF_COUPON,
        PAYOFF_CALLABILITY_CALLABILITY,
        PAYOFF_PARTICIPATION,
      ],
      hidden: true,
    },
    {
      formControlNames: [SUMMARY_UNDERLYING_ASSETS_GROUP],
      hidden: false,
    },
    {
      formControlNames: [
        SUMMARY_FREQUENCY,
        SUMMARY_SETTLEMENT_TYPE,
        SUMMARY_PERFORMANCE_TYPE,
      ],
      readOnly: false,
    },
    {
      formControlNames: [
        PAYOFF_COUPON_TYPE,
        PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
        PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
        PAYOFF_PARTICIPATION_UPSIDE_TYPE,
        PAYOFF_PARTICIPATION_BASE_TYPE,
        PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE,
      ],
      hidden: true,
      selectValues: ['NONE'],
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_BASE_TYPE],
      selectValues: [BaseTypeEnum.BONUS_CERTIFICATE],
      hidden: false,
    },
  ],
};
